// SplashScreen.js
import React from 'react';
import './SplashScreen.css';
import logo from './password.png';

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <img src={logo} alt="App Logo" />
    </div>
  );
};

export default SplashScreen;
